/* Load and autoplay storefront videos only when they approach the viewport. */
(function () {
  if (window.WearoLazyVideo) return;

  function load(video) {
    if (!video || video.dataset.wearoLoaded === 'true') return video;

    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }

    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      delete source.dataset.src;
    });

    video.dataset.wearoLoaded = 'true';
    video.load();
    return video;
  }

  function play(video) {
    load(video);
    var started = video.play();
    if (started && started.catch) started.catch(function () {});
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;

            if (entry.isIntersecting) {
              load(video);
              if (video.dataset.autoplay === 'true') play(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        /* Keep off-screen reels inert. A small margin prepares the poster/video
           just before it becomes visible without loading the whole reel row on
           the initial viewport. */
        { rootMargin: '50px 0px', threshold: 0.01 }
      )
    : null;

  function observe(root) {
    root.querySelectorAll('video[data-wearo-lazy-video]').forEach(function (video) {
      if (video.dataset.wearoObserved === 'true') return;
      video.dataset.wearoObserved = 'true';

      if (video.dataset.loadOnInteraction === 'true') return;

      if (observer) observer.observe(video);
      else {
        load(video);
        if (video.dataset.autoplay === 'true') play(video);
      }
    });
  }

  window.WearoLazyVideo = { load: load, play: play, observe: observe };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    document.querySelectorAll('video[data-wearo-lazy-video]').forEach(function (video) {
      if (!video.paused) video.pause();
    });
  });
})();
